export { isAddress as isEvmAddress } from 'ethers/lib/utils';
import { isEvmBlockchain } from 'rango-types';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var IS_DEV = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
var getBlockChainNameFromId = function getBlockChainNameFromId(chainId, blockchains) {
  var _blockchains$filter$f;
  chainId = typeof chainId === 'string' && chainId.startsWith('0x') ? parseInt(chainId) : chainId;
  // Sometimes providers are passing `Network` as chainId.
  // If chainId is a `Network`, we return itself.
  var allNetworks = Object.values(Network);
  if (allNetworks.includes(String(chainId))) return chainId;
  if (chainId === 'Binance-Chain-Tigris') return Network.BINANCE;
  return ((_blockchains$filter$f = blockchains.filter(function (blockchainMeta) {
    return !!blockchainMeta.chainId;
  }).find(function (blockchainMeta) {
    var _blockchainMeta$chain;
    var blockchainChainId = (_blockchainMeta$chain = blockchainMeta.chainId) != null && _blockchainMeta$chain.startsWith('0x') ? parseInt(blockchainMeta.chainId) : blockchainMeta.chainId;
    return blockchainChainId == chainId;
  })) == null ? void 0 : _blockchains$filter$f.name) || null;
};
var getBlockchainChainIdByName = function getBlockchainChainIdByName(netwok, allBlockChains) {
  var _allBlockChains$netwo;
  return ((_allBlockChains$netwo = allBlockChains[netwok]) == null ? void 0 : _allBlockChains$netwo.chainId) || null;
};
var uint8ArrayToHex = function uint8ArrayToHex(buffer) {
  return Buffer.from(buffer).toString('hex');
};
var WalletType;
(function (WalletType) {
  WalletType["META_MASK"] = "metamask";
  WalletType["WALLET_CONNECT"] = "wallet-connect";
  WalletType["TRUST_WALLET"] = "trust-wallet";
  WalletType["KEPLR"] = "keplr";
  WalletType["PHANTOM"] = "phantom";
  WalletType["BINANCE_CHAIN"] = "binance-chain";
  WalletType["TRON_LINK"] = "tron-link";
  WalletType["COINBASE"] = "coinbase";
  WalletType["XDEFI"] = "xdefi";
  WalletType["CLOVER"] = "clover";
  WalletType["ARGENTX"] = "argentx";
  WalletType["FRONTIER"] = "frontier";
  WalletType["COSMOSTATION"] = "cosmostation";
  WalletType["COIN98"] = "coin98";
  WalletType["SAFEPAL"] = "safepal";
  WalletType["TOKEN_POCKET"] = "token-pocket";
  WalletType["BRAVE"] = "brave";
  WalletType["MATH"] = "math";
  WalletType["EXODUS"] = "exodus";
  WalletType["OKX"] = "okx";
  WalletType["KUCOIN"] = "kucoin";
  WalletType["LEAP"] = "leap";
  WalletType["LEAP_COSMOS"] = "leap-cosmos";
  WalletType["STATION"] = "station";
  WalletType["UNKNOWN"] = "unknown";
  WalletType["ENKRYPT"] = "enkrypt";
})(WalletType || (WalletType = {}));
var Network;
(function (Network) {
  Network["BTC"] = "BTC";
  Network["BSC"] = "BSC";
  Network["LTC"] = "LTC";
  Network["THORCHAIN"] = "THOR";
  Network["BCH"] = "BCH";
  Network["BINANCE"] = "BNB";
  Network["ETHEREUM"] = "ETH";
  Network["POLYGON"] = "POLYGON";
  Network["TERRA"] = "TERRA";
  Network["POLKADOT"] = "";
  Network["TRON"] = "TRON";
  Network["DOGE"] = "DOGE";
  Network["HARMONY"] = "HARMONY";
  Network["AVAX_CCHAIN"] = "AVAX_CCHAIN";
  Network["FANTOM"] = "FANTOM";
  Network["MOONBEAM"] = "MOONBEAM";
  Network["ARBITRUM"] = "ARBITRUM";
  Network["BOBA"] = "BOBA";
  Network["OPTIMISM"] = "OPTIMISM";
  Network["FUSE"] = "FUSE";
  Network["CRONOS"] = "CRONOS";
  Network["SOLANA"] = "SOLANA";
  Network["MOONRIVER"] = "MOONRIVER";
  Network["GNOSIS"] = "GNOSIS";
  Network["COSMOS"] = "COSMOS";
  Network["OSMOSIS"] = "OSMOSIS";
  Network["AKASH"] = "AKASH";
  Network["IRIS"] = "IRIS";
  Network["PERSISTENCE"] = "PERSISTENCE";
  Network["SENTINEL"] = "SENTINEL";
  Network["REGEN"] = "REGEN";
  Network["CRYPTO_ORG"] = "CRYPTO_ORG";
  Network["SIF"] = "SIF";
  Network["CHIHUAHUA"] = "CHIHUAHUA";
  Network["JUNO"] = "JUNO";
  Network["KUJIRA"] = "KUJIRA";
  Network["STARNAME"] = "STARNAME";
  Network["COMDEX"] = "COMDEX";
  Network["STARGAZE"] = "STARGAZE";
  Network["DESMOS"] = "DESMOS";
  Network["BITCANNA"] = "BITCANNA";
  Network["SECRET"] = "SECRET";
  Network["INJECTIVE"] = "INJECTIVE";
  Network["LUMNETWORK"] = "LUMNETWORK";
  Network["BANDCHAIN"] = "BANDCHAIN";
  Network["EMONEY"] = "EMONEY";
  Network["BITSONG"] = "BITSONG";
  Network["KI"] = "KI";
  Network["MEDIBLOC"] = "MEDIBLOC";
  Network["KONSTELLATION"] = "KONSTELLATION";
  Network["UMEE"] = "UMEE";
  Network["STARKNET"] = "STARKNET";
  // Using instead of null
  Network["Unknown"] = "Unkown";
})(Network || (Network = {}));
var XDEFI_WALLET_SUPPORTED_NATIVE_CHAINS = [Network.BTC, Network.LTC, Network.THORCHAIN, Network.BCH, Network.BINANCE];
var KEPLR_COMPATIBLE_WALLETS = [WalletType.KEPLR, WalletType.COSMOSTATION];

function deepCopy(obj) {
  var copy;
  // Handle the 3 simple types, and null or undefined
  if (null == obj || 'object' != typeof obj) return obj;
  // Handle Date
  if (obj instanceof Date) {
    copy = new Date();
    copy.setTime(obj.getTime());
    return copy;
  }
  // Handle Array
  if (obj instanceof Array) {
    copy = [];
    for (var i = 0, len = obj.length; i < len; i++) {
      copy[i] = deepCopy(obj[i]);
    }
    return copy;
  }
  // Handle Object
  if (obj instanceof Object) {
    copy = {};
    for (var attr in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, attr)) copy[attr] = deepCopy(obj[attr]);
    }
    return copy;
  }
  throw new Error("Unable to copy obj! Its type isn't supported.");
}
function switchOrAddNetworkForMetamaskCompatibleWallets(_x, _x2, _x3) {
  return _switchOrAddNetworkForMetamaskCompatibleWallets.apply(this, arguments);
}
function _switchOrAddNetworkForMetamaskCompatibleWallets() {
  _switchOrAddNetworkForMetamaskCompatibleWallets = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(instance, network, evmNetworksChainInfo) {
    var targetChain, error;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          targetChain = evmNetworksChainInfo[network];
          _context2.prev = 1;
          _context2.next = 4;
          return instance.request({
            method: 'wallet_switchEthereumChain',
            params: [{
              chainId: targetChain == null ? void 0 : targetChain.chainId
            }]
          });
        case 4:
          _context2.next = 17;
          break;
        case 6:
          _context2.prev = 6;
          _context2.t0 = _context2["catch"](1);
          // @ts-ignore
          // To resolve this error: Catch clause variable type annotation must be any or unknown if specified
          error = _context2.t0;
          if (targetChain) {
            _context2.next = 13;
            break;
          }
          throw new Error("It seems you don't have " + network + " network on your wallet. Please add it manually.");
        case 13:
          if (!(error.code === 4902 || !error.code)) {
            _context2.next = 16;
            break;
          }
          _context2.next = 16;
          return instance.request({
            method: 'wallet_addEthereumChain',
            params: [targetChain]
          });
        case 16:
          throw _context2.t0;
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 6]]);
  }));
  return _switchOrAddNetworkForMetamaskCompatibleWallets.apply(this, arguments);
}
function timeout(forPromise, time) {
  var timeoutPromise = new Promise(function (_, reject) {
    setTimeout(function () {
      reject('Timeout!');
    }, time);
  });
  return Promise.race([forPromise, timeoutPromise]);
}
var convertEvmBlockchainMetaToEvmChainInfo = function convertEvmBlockchainMetaToEvmChainInfo(evmBlockchains) {
  return evmBlockchains.reduce(function (evmNetWorksChainInfo, blockchainMeta) {
    return evmNetWorksChainInfo[blockchainMeta.name] = {
      chainName: blockchainMeta.info.chainName,
      chainId: blockchainMeta.chainId,
      nativeCurrency: blockchainMeta.info.nativeCurrency,
      rpcUrls: blockchainMeta.info.rpcUrls,
      blockExplorerUrls: blockchainMeta.info.blockExplorerUrls
    }, evmNetWorksChainInfo;
  }, {});
};
var evmChainsToRpcMap = function evmChainsToRpcMap(evmNetworkChainInfo) {
  return Object.fromEntries(new Map(Object.keys(evmNetworkChainInfo).map(function (chainName) {
    var info = evmNetworkChainInfo[chainName];
    // This `if` is only used for satisfying typescript,
    // Because we iterating over Object.keys(EVM_NETWORKS_CHAIN_INFO)
    // And obviously it cannot be `undefined` and always has a value.
    if (!!info) {
      return [parseInt(info.chainId), info.rpcUrls[0]];
    }
    return [0, ''];
  })));
};
var getSolanaAccounts = /*#__PURE__*/function () {
  var _ref2 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var instance, solanaResponse, account;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          instance = _ref.instance;
          _context.prev = 1;
          _context.next = 4;
          return instance.connect();
        case 4:
          solanaResponse = _context.sent;
          _context.next = 10;
          break;
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](1);
          throw _context.t0;
        case 10:
          account = solanaResponse.publicKey.toString();
          return _context.abrupt("return", {
            accounts: [account],
            chainId: Network.SOLANA
          });
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 7]]);
  }));
  return function getSolanaAccounts(_x4) {
    return _ref2.apply(this, arguments);
  };
}();
function getCoinbaseInstance(lookingFor) {
  if (lookingFor === void 0) {
    lookingFor = 'coinbase';
  }
  var _window = window,
    ethereum = _window.ethereum,
    coinbaseSolana = _window.coinbaseSolana;
  var instances = new Map();
  if (!!ethereum) {
    var _ethereum$providers;
    var checker = lookingFor === 'metamask' ? 'isMetaMask' : 'isCoinbaseWallet';
    // If only Coinbase Wallet is installed
    if (lookingFor === 'coinbase' && ethereum[checker]) {
      instances.set(Network.ETHEREUM, ethereum);
    }
    // If Coinbase Wallet and Metamask is installed at the same time.
    else if ((_ethereum$providers = ethereum.providers) != null && _ethereum$providers.length) {
      var ethInstance = ethereum.providers.find(function (provider) {
        return provider[checker];
      });
      instances.set(Network.ETHEREUM, ethInstance);
    }
  }
  if (!!coinbaseSolana && lookingFor === 'coinbase') instances.set(Network.SOLANA, coinbaseSolana);
  if (instances.size === 0) return null;
  if (lookingFor === 'metamask') return instances.get(Network.ETHEREUM);
  return instances;
}
function sortWalletsBasedOnState(wallets) {
  return wallets.sort(function (a, b) {
    return Number(b.connected) - Number(a.connected) || Number(b.extensionAvailable) - Number(a.extensionAvailable);
  });
}
function isBrave() {
  var isBrave = false;
  var nav = navigator;
  if (nav.brave && nav.brave.isBrave) {
    nav.brave.isBrave().then(function (res) {
      if (res) isBrave = true;
    });
  }
  return isBrave;
}
function detectInstallLink(install) {
  if (typeof install !== 'object') {
    return install;
  } else {
    var _navigator$userAgent, _navigator$userAgent2, _navigator$userAgent3;
    var link;
    if (isBrave()) {
      link = install.BRAVE;
    } else if (((_navigator$userAgent = navigator.userAgent) == null ? void 0 : _navigator$userAgent.toLowerCase().indexOf('chrome')) !== -1) {
      link = install.CHROME;
    } else if (((_navigator$userAgent2 = navigator.userAgent) == null ? void 0 : _navigator$userAgent2.toLowerCase().indexOf('firefox')) !== -1) {
      link = install.FIREFOX;
    } else if (((_navigator$userAgent3 = navigator.userAgent) == null ? void 0 : _navigator$userAgent3.toLowerCase().indexOf('edge')) !== -1) {
      link = install.EDGE;
    }
    return link || install.DEFAULT;
  }
}
function detectMobileScreens() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function getEvmAccounts(_x) {
  return _getEvmAccounts.apply(this, arguments);
}
function _getEvmAccounts() {
  _getEvmAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(instance) {
    var _yield$Promise$all, accounts, chainId;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return Promise.all([instance.request({
            method: 'eth_requestAccounts'
          }), instance.request({
            method: 'eth_chainId'
          })]);
        case 2:
          _yield$Promise$all = _context2.sent;
          accounts = _yield$Promise$all[0];
          chainId = _yield$Promise$all[1];
          return _context2.abrupt("return", {
            accounts: accounts,
            chainId: chainId
          });
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getEvmAccounts.apply(this, arguments);
}
var subscribeToEvm = function subscribeToEvm(_ref) {
  var instance = _ref.instance,
    state = _ref.state,
    updateChainId = _ref.updateChainId,
    updateAccounts = _ref.updateAccounts;
  instance == null ? void 0 : instance.on('accountsChanged', function (addresses) {
    // TODO: after enabling autoconnect, we can consider this condition
    // to be removed.
    // The problem was if a user already connected its wallet,
    // Metamask is triggering this event on first load, so when autoconnect is disabled,
    // it's automaticlally change the state of wallet to `connected`.
    if (state.connected) {
      updateAccounts(addresses);
    }
  });
  instance == null ? void 0 : instance.on('chainChanged', function (chainId) {
    updateChainId(chainId);
  });
};
var switchNetworkForEvm = /*#__PURE__*/function () {
  var _ref3 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
    var instance, network, meta, evmBlockchains, evmInstance;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          instance = _ref2.instance, network = _ref2.network, meta = _ref2.meta;
          evmBlockchains = meta.filter(isEvmBlockchain);
          evmInstance = getNetworkInstance(instance, Network.ETHEREUM);
          _context.next = 5;
          return switchOrAddNetworkForMetamaskCompatibleWallets(evmInstance, network, convertEvmBlockchainMetaToEvmChainInfo(evmBlockchains));
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function switchNetworkForEvm(_x2) {
    return _ref3.apply(this, arguments);
  };
}();
var canSwitchNetworkToEvm = function canSwitchNetworkToEvm(_ref4) {
  var network = _ref4.network,
    meta = _ref4.meta;
  return evmNetworkNames(meta).includes(network);
};
function evmNetworkNames(meta) {
  return meta.filter(isEvmBlockchain).map(function (blockchain) {
    return blockchain.name;
  });
}
function getEthChainsInstance(network, meta) {
  if (!network) return null;
  var evmBlockchains = evmNetworkNames(meta);
  return evmBlockchains.includes(network) ? Network.ETHEREUM : null;
}
function isEvmNetwork(network, meta) {
  if (!network) return false;
  return evmNetworkNames(meta).includes(network);
}
function chooseInstance(instances, meta, network) {
  // If there is no `network` we fallback to default network.
  network = network || Network.ETHEREUM;
  var instance_network_name = isEvmNetwork(network, meta) ? getEthChainsInstance(network, meta) : network;
  var instance = !!instances && !!instance_network_name ? instances.get(instance_network_name) : null;
  return instance;
}
function getNetworkInstance(provider, network) {
  return provider.size ? provider.get(network) : provider;
}

var _excluded = ["experimental"];
var getCosmosMainChainsIds = function getCosmosMainChainsIds(blockchains) {
  return blockchains.filter(function (blockchain) {
    var _blockchain$info;
    return !((_blockchain$info = blockchain.info) != null && _blockchain$info.experimental);
  }).map(function (blockchain) {
    return blockchain.chainId;
  }).filter(function (chainId) {
    return !!chainId;
  });
};
var getCosmosMiscChainsIds = function getCosmosMiscChainsIds(blockchains) {
  return blockchains.filter(function (blockchain) {
    var _blockchain$info2;
    return (_blockchain$info2 = blockchain.info) == null ? void 0 : _blockchain$info2.experimental;
  }).map(function (blockchain) {
    return blockchain.chainId;
  }).filter(function (chainId) {
    return !!chainId;
  });
};
var getCosmosExperimentalChainInfo = function getCosmosExperimentalChainInfo(blockchains) {
  return blockchains.filter(function (blockchain) {
    return !!blockchain.info;
  }).filter(function (blockchain) {
    return !!blockchain.chainId;
  }).reduce(function (cosmosExperimentalChainsInfo, blockchain) {
    var info = deepCopy(blockchain.info);
    info.stakeCurrency.coinImageUrl = window.location.origin + info.stakeCurrency.coinImageUrl;
    info.currencies = info.currencies.map(function (currency) {
      return _extends({}, currency, {
        coinImageUrl: window.location.origin + currency.coinImageUrl
      });
    });
    info.feeCurrencies = info.feeCurrencies.map(function (currency) {
      return _extends({}, currency, {
        coinImageUrl: window.location.origin + currency.coinImageUrl
      });
    });
    if (!info.gasPriceStep) delete info.gasPriceStep;
    var experimental = info.experimental,
      otherProperties = _objectWithoutPropertiesLoose(info, _excluded);
    return cosmosExperimentalChainsInfo[blockchain.name] = {
      id: blockchain.chainId,
      info: _extends({}, otherProperties, {
        chainId: blockchain.chainId
      }),
      experimental: experimental
    }, cosmosExperimentalChainsInfo;
  }, {});
};
function getMainAccounts(_x) {
  return _getMainAccounts.apply(this, arguments);
}
function _getMainAccounts() {
  _getMainAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref) {
    var desiredChainIds, instance, offlineSigners, accountsPromises, availableAccountForChains, resolvedAccounts;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          desiredChainIds = _ref.desiredChainIds, instance = _ref.instance;
          // Trying to get accounts from all chains
          offlineSigners = desiredChainIds.map(function (chainId) {
            var signer = instance.getOfflineSigner(chainId);
            return {
              signer: signer,
              chainId: chainId
            };
          }).filter(Boolean);
          accountsPromises = offlineSigners.map(function (_ref5) {
            var signer = _ref5.signer;
            return signer.getAccounts();
          });
          _context2.next = 5;
          return Promise.allSettled(accountsPromises);
        case 5:
          availableAccountForChains = _context2.sent;
          resolvedAccounts = [];
          availableAccountForChains.forEach(function (result, index) {
            if (result.status !== 'fulfilled') return;
            var accounts = result.value;
            var chainId = offlineSigners[index].chainId;
            var addresses = accounts.map(function (account) {
              return account.address;
            });
            resolvedAccounts.push({
              accounts: addresses,
              chainId: chainId
            });
          });
          return _context2.abrupt("return", resolvedAccounts);
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getMainAccounts.apply(this, arguments);
}
function tryRequestMiscAccounts(_x2) {
  return _tryRequestMiscAccounts.apply(this, arguments);
}
function _tryRequestMiscAccounts() {
  _tryRequestMiscAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref2) {
    var excludedChain, instance, meta, offlineSigners, accountsPromises, availableAccountForChains, resolvedAccounts;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          excludedChain = _ref2.excludedChain, instance = _ref2.instance, meta = _ref2.meta;
          offlineSigners = getCosmosMiscChainsIds(meta).filter(function (id) {
            return id !== excludedChain;
          }).map(function (chainId) {
            var signer = instance.getOfflineSigner(chainId);
            return {
              signer: signer,
              chainId: chainId
            };
          });
          accountsPromises = offlineSigners.map(function (_ref6) {
            var signer = _ref6.signer;
            return signer.getAccounts();
          });
          _context3.next = 5;
          return Promise.allSettled(accountsPromises);
        case 5:
          availableAccountForChains = _context3.sent;
          resolvedAccounts = [];
          availableAccountForChains.forEach(function (result, index) {
            if (result.status !== 'fulfilled') return;
            var accounts = result.value;
            var chainId = offlineSigners[index].chainId;
            var addresses = accounts.map(function (account) {
              return account.address;
            });
            resolvedAccounts.push({
              accounts: addresses,
              chainId: chainId
            });
          });
          return _context3.abrupt("return", resolvedAccounts);
        case 9:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _tryRequestMiscAccounts.apply(this, arguments);
}
var getCosmosAccounts = /*#__PURE__*/function () {
  var _ref4 = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref3) {
    var instance, network, meta, chainInfo, desiredChainIds, mainAccounts, exclude, miscAccounts, results;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          instance = _ref3.instance, network = _ref3.network, meta = _ref3.meta;
          chainInfo = network ? getCosmosExperimentalChainInfo(meta)[network] : null;
          if (!(!!network && !chainInfo)) {
            _context.next = 4;
            break;
          }
          throw new Error("You need to add " + network + " to \"COSMOS_EXPERIMENTAL_CHAINS_INFO\" first.");
        case 4:
          if (!chainInfo) {
            _context.next = 7;
            break;
          }
          _context.next = 7;
          return instance.experimentalSuggestChain(chainInfo.info);
        case 7:
          // Getting main chains + target network
          desiredChainIds = getCosmosMainChainsIds(meta);
          if (!!chainInfo) {
            desiredChainIds.push(chainInfo.id);
          }
          desiredChainIds = Array.from(new Set(desiredChainIds)).filter(Boolean);
          _context.next = 12;
          return instance.enable(desiredChainIds);
        case 12:
          _context.next = 14;
          return getMainAccounts({
            desiredChainIds: desiredChainIds,
            instance: instance
          });
        case 14:
          mainAccounts = _context.sent;
          exclude = !!chainInfo ? chainInfo.id : undefined;
          if (!exclude) {
            _context.next = 22;
            break;
          }
          _context.next = 19;
          return tryRequestMiscAccounts({
            instance: instance,
            meta: meta,
            excludedChain: exclude
          });
        case 19:
          _context.t0 = _context.sent;
          _context.next = 23;
          break;
        case 22:
          _context.t0 = [];
        case 23:
          miscAccounts = _context.t0;
          results = [].concat(mainAccounts, miscAccounts);
          return _context.abrupt("return", results);
        case 26:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getCosmosAccounts(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

export { IS_DEV, KEPLR_COMPATIBLE_WALLETS, Network, WalletType, XDEFI_WALLET_SUPPORTED_NATIVE_CHAINS, canSwitchNetworkToEvm, chooseInstance, convertEvmBlockchainMetaToEvmChainInfo, deepCopy, detectInstallLink, detectMobileScreens, evmChainsToRpcMap, evmNetworkNames, getBlockChainNameFromId, getBlockchainChainIdByName, getCoinbaseInstance, getCosmosAccounts, getCosmosExperimentalChainInfo, getEthChainsInstance, getEvmAccounts, getNetworkInstance, getSolanaAccounts, sortWalletsBasedOnState, subscribeToEvm, switchNetworkForEvm, switchOrAddNetworkForMetamaskCompatibleWallets, timeout, uint8ArrayToHex };
//# sourceMappingURL=wallets-shared.esm.js.map
